import { useEffect } from "react";
import { IDiscordMessageGroup } from "#api/discord";
import { MessageGroup } from "./message_group";

import * as styles from "./styles.module.scss";

interface IProps {
  messages: IDiscordMessageGroup[];
  messageId: string | undefined;
}

export function MessageList({ messages, messageId }: IProps) {
  // const [offset, setOffset] = useState(0);
  // const parentRef = useRef<HTMLElement>(null);
  // const [messages, setMessages] = useState({ lastPage: [] as IDiscordMessage[], thisPage: [] as IDiscordMessage[], nextPage: [] as IDiscordMessage[] });
  // const [isFetchingNextPage, setIsFetchingNextPage] = useState(false);
  // const [isFetchingPreviousPage, setIsFetchingPreviousPage] = useState(false);
  // const virtualizer = useVirtualizer({
  //   count: [...messages.lastPage, ...messages.thisPage, ...messages.nextPage].length,
  //   getScrollElement: () => parentRef.current,
  //   estimateSize: () => 450,
  //   enabled: true,
  // });
  // const items = virtualizer.getVirtualItems();

  // async function fetchPreviousPage() {
  //   if (isFetchingNextPage || isFetchingPreviousPage || !channelId) return;
  //   setIsFetchingPreviousPage(true);

  //   try {
  //     offset = offset <= PAGE_SIZE ? 0 : offset - PAGE_SIZE;
  //     let newMessages = (await fetchDiscordMessages(channelId, offset)).sort((a, b) => a.published_date.valueOf() - b.published_date.valueOf());
  //     setMessages(oldMessages => ({
  //       lastPage: oldMessages.thisPage,
  //       thisPage: oldMessages.nextPage,
  //       nextPage: newMessages,
  //     }));
  //   } finally {
  //     setIsFetchingPreviousPage(false);
  //   }
  // }

  // async function fetchNextPage() {
  //   if (isFetchingNextPage || isFetchingPreviousPage || !channelId) return;
  //   setIsFetchingNextPage(true);
  //   console.log("Fetching next")

  //   try {
  //     offset = offset + PAGE_SIZE;
  //     let newMessages = (await fetchDiscordMessages(channelId, offset)).sort((a, b) => a.published_date.valueOf() - b.published_date.valueOf());
  //     setMessages(oldMessages => ({
  //       lastPage: newMessages,
  //       thisPage: oldMessages.nextPage,
  //       nextPage: oldMessages.thisPage,
  //     }));
  //   } finally {
  //     setIsFetchingNextPage(false);
  //   }
  // }

  // useEffect(() => {
  //   fetchPreviousPage();
  // }, []);

  // async function onScroll(event: MouseEvent<HTMLElement>) {
  //   let el = event.target as HTMLElement;
  //   if (el.scrollTop < 100) {
  //     fetchNextPage();
  //   } else if (el.scrollTop >= el.scrollHeight - 100) {
  //     fetchPreviousPage();
  //   }
  // }

  // if (error) {
  //   return <>{error.message}</>
  // };

  // if (isPending) {
  //   return <>Loading...</>
  // }

  // return (
  //   <InfiniteLoader itemCount={999_999_999 /* unknown */} isItemLoaded={() => false} loadMoreItems={(e) => console.log(e)}>
  //     <List
  //   </InfiniteLoader>
  // )

  useEffect(() => {
    if (messageId) {
      document.getElementById(`message-${messageId}`)?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <main className={styles.messageList}>
      {messages.map(group => (
        <MessageGroup group={group} />
      ))}
    </main>
  );
};
